import React from 'react';
import * as blueshift from '../../../helpers/blueshift';
import { Button } from 'tradera/components/atoms/button/button';
import { useIsFeatureEnabled } from 'tradera/hooks/use-is-feature-enabled';
import { ScrollableModal } from 'tradera/components/scrollable-modal/scrollable-modal';
import { Trans, useTranslator } from 'tradera/lang/translate';
import { Heading } from 'tradera/components/atoms/heading/heading';

type MarketingProps = { isDefaultChecked?: boolean };

export const Marketing = ({ isDefaultChecked = true }: MarketingProps) => {
    const { t } = useTranslator();
    const [show, setShow] = React.useState(false);
    const isModalEnabled = useIsFeatureEnabled('registration-marketing-modal');
    return (
        <>
            <div className="form-check">
                <input
                    type="checkbox"
                    id="marketing"
                    className="form-check-input"
                    onChange={(e) =>
                        blueshift.setAcceptsMarketing(e.target.checked)
                    }
                    defaultChecked={
                        !isDefaultChecked
                            ? false
                            : blueshift.getAcceptsMarketing()
                    }
                />
                <label htmlFor="marketing" className="form-check-label">
                    {t('registration_marketing_label')}
                </label>
            </div>
            {isModalEnabled && (
                <Button
                    className="mb-2"
                    onClick={() => setShow(true)}
                    theme="link">
                    {t('registration_howYourDataIsUsed_label')}
                </Button>
            )}
            <ScrollableModal
                maxWidth="45rem"
                maxHeight="60rem"
                onClose={() => setShow(false)}
                mobileBottomSheet
                show={show}
                title={t('marketing_registration_modal_heading')}>
                <Trans
                    i18nKey="marketing_registration_modal_withLink_bodyTrans"
                    components={{
                        heading: <Heading as="h5" className="mb-1" />,
                        readMoreLink: <Button theme="link" target="_blank" />
                    }}
                />
            </ScrollableModal>
        </>
    );
};
